/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Integrations_Zotero_Disconnect_Confirm_DescriptionInputs */

const en_settings_integrations_zotero_disconnect_confirm_description = /** @type {(inputs: Settings_Integrations_Zotero_Disconnect_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can reconnect Zotero later from Settings.`)
};

const es_settings_integrations_zotero_disconnect_confirm_description = /** @type {(inputs: Settings_Integrations_Zotero_Disconnect_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes volver a conectar Zotero más tarde desde Configuración.`)
};

/**
* | output |
* | --- |
* | "You can reconnect Zotero later from Settings." |
*
* @param {Settings_Integrations_Zotero_Disconnect_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_integrations_zotero_disconnect_confirm_description = /** @type {((inputs?: Settings_Integrations_Zotero_Disconnect_Confirm_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Integrations_Zotero_Disconnect_Confirm_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_integrations_zotero_disconnect_confirm_description(inputs)
	return en_settings_integrations_zotero_disconnect_confirm_description(inputs)
});